import type { Entity, ID } from "../../../../../core/types/fe";

export const AcceptMode = {
    ONLINE: { key: "enum.acceptMode.fullOnline", value: "FULL_ONLINE" },
    OFFLINE: { key: "enum.acceptMode.offline", value: "OFFLINE" },
    DEGRADED: { key: "enum.acceptMode.degraded", value: "DEGRADED" },
};

export interface ContractAppProfileEntity extends Entity {
    readOnly?: boolean;
    cardTypeId?: ID;
    cardTypeName?: string;
    acceptMode?: string;
    routingId?: number;
    merchantId?: string;
    hostOperatorId?: number;
}
